const newDisplay = "💥NEW💥";

const biscuitOptionsGift = [
  {
		"sku" : "CRA-BMU-PARTY",
		"name" : "Seasonal: Butter Murukku Crackers",
    unit: "g",
		"weight" : 30
	},
	{
		"sku" : "CRA-PAG-PARTY",
		"name" : "Seasonal: Pagoda Murukku Crackers",
    unit: "g",
		"weight" : 30
	},
	{
		"sku" : "CRA-SMU-PARTY",
		"name" : "Seasonal: Spicy Murukku Crackers",
    unit: "g",
		"weight" : 30
	},
	{
		"sku" : "CRA-STA-PARTY",
		"name" : "Seasonal: Star Murukku Crackers",
    unit: "g",
		"weight" : 30
	},
  {
    name: "Couch Potato Wheel Crackers",
    sku: "CRA-PWH-GIFT",
    popular: true,
    weight: 10,
    unit: "g",
    tooltip: "The wheels on the bus go potatoes..",
  },
  {
    name: "Senbei Rice Crackers",
    sku: "RCRA-BBQ-GIFT",
    popular: true,
    weight: 30,
    unit: "g",
    tooltip: "BBQ flavoured rice cracker",
  },
  {
    name: "Happy Pineapple Tarts",
    sku: "PAT-HAP-GIFT",
    popular: true,
    weight: 30,
    unit: "g",
    tooltip: "Greeting you with a smile",
  },
  {
    name: "Flying Burger Balls Medley",
    sku: "MIX-FBB-GIFT",
    popular: true,
    weight: 30,
    unit: "g",
    tooltip: "It is possible to get everything you want.",
  },
  {
    name: "Seaweed Biscuits",
    sku: "BIS-SEA-GIFT",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "We always grab a handful when we eat this",
  },
  {
    name: "Nostalgic Iced Gem",
    sku: "ICG-TRA-GIFT",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "Classic iced gems",
  },
  {
    name: "ABC Alphabet Biscuits",
    sku: "BIS-ABC-GIFT",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "Form up your name and eat them!",
  },
  {
    name: "Butter Murukku Crackers",
    sku: "CRA-BMU-GIFT",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "Classic dal snack",
  },
  {
    name: "Cigar Chocolate Rolls",
    sku: "ROL-CHO-GIFT",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "Take a puff and bite.",
  },
  {
    name: "Rainbow Strawberry Rolls",
    sku: "ROL-RAI-GIFT",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "Ride on the wild curve!",
  },
  {
    name: "Butterfly Ear Biscuits",
    sku: "BIS-EAR-GIFT",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "Don't pull your ear, eat some ear biscuits.",
  },
  {
    name: "Shredded Tapioca Fries",
    sku: "TAP-FRI-GIFT",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "Must try if you like fries.",
  },
];

const biscuitOptionsParty = [
  {
		"sku" : "CRA-BMU-PARTY",
		"name" : "Seasonal: Butter Murukku Crackers",
    unit: "g",
		"weight" : 10
	},
	{
		"sku" : "CRA-PAG-PARTY",
		"name" : "Seasonal: Pagoda Murukku Crackers",
    unit: "g",
		"weight" : 10
	},
	{
		"sku" : "CRA-SMU-PARTY",
		"name" : "Seasonal: Spicy Murukku Crackers",
    unit: "g",
		"weight" : 10
	},
	{
		"sku" : "CRA-STA-PARTY",
		"name" : "Seasonal: Star Murukku Crackers",
    unit: "g",
		"weight" : 10
	},
  {
    name: "Couch Potato Wheel Crackers",
    sku: "CRA-PWH-PARTY",
    popular: true,
    weight: 2,
    unit: "g",
    tooltip: "The wheels on the bus go potatoes..",
  },
  {
    name: "Senbei Rice Crackers",
    sku: "RCRA-BBQ-PARTY",
    popular: true,
    weight: 10,
    unit: "g",
    tooltip: "BBQ flavoured rice cracker",
  },
  {
    name: "Happy Pineapple Tarts",
    sku: "PAT-HAP-PARTY",
    popular: true,
    weight: 10,
    unit: "g",
    tooltip: "Greeting you with a smile",
  },
  {
    name: "Flying Burger Balls Medley",
    sku: "MIX-FBB-PARTY",
    popular: true,
    weight: 10,
    unit: "g",
    tooltip: "It is possible to get everything you want.",
  },
  {
    name: "Seaweed Biscuits",
    sku: "BIS-SEA-PARTY",
    popular: false,
    weight: 10,
    unit: "g",
    tooltip: "We always grab a handful when we eat this",
  },
  {
    name: "Nostalgic Iced Gem",
    sku: "ICG-TRA-PARTY",
    popular: false,
    weight: 10,
    unit: "g",
    tooltip: "Classic iced gems",
  },
  {
    name: "ABC Alphabet Biscuits",
    sku: "BIS-ABC-PARTY",
    popular: false,
    weight: 10,
    unit: "g",
    tooltip: "Form up your name and eat them!",
  },
  {
    name: "Butter Murukku Crackers",
    sku: "CRA-BMU-PARTY",
    popular: false,
    weight: 10,
    unit: "g",
    tooltip: "Classic dal snack",
  },
  {
    name: "Butterfly Ear Biscuits",
    sku: "BIS-EAR-PARTY",
    popular: false,
    weight: 10,
    unit: "g",
    tooltip: "Don't pull your ear, eat some ear biscuits.",
  },
  {
    name: "Shredded Tapioca Fries",
    sku: "TAP-FRI-PARTY",
    popular: false,
    weight: 10,
    unit: "g",
    tooltip: "Must try if you like fries.",
  },
];

const biscuitOptionsRetail = [
  {
    name: "Couch Potato Wheel Crackers",
    sku: "CRA-PWH-RET",
    popular: true,
    weight: 40,
    unit: "g",
    tooltip: "The wheels on the bus go potatoes..",
  },
  {
    name: "Senbei Rice Crackers",
    sku: "RCRA-BBQ-100",
    popular: true,
    weight: 100,
    unit: "g",
    tooltip: "BBQ flavoured rice cracker",
  },
  {
    name: "Happy Pineapple Tarts",
    sku: "PAT-HAP-150",
    popular: true,
    weight: 150,
    unit: "g",
    tooltip: "Greeting you with a smile",
  },
  {
    name: "Flying Burger Balls Medley",
    sku: "MIX-FBB-150",
    popular: true,
    weight: 150,
    unit: "g",
    tooltip: "It is possible to get everything you want.",
  },
  {
    name: "Seaweed Biscuits",
    sku: "BIS-SEA-120",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "We always grab a handful when we eat this",
  },
  {
    name: "Nostalgic Iced Gem",
    sku: "ICG-TRA-120",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "Classic iced gems",
  },
  {
    name: "ABC Alphabet Biscuits",
    sku: "BIS-ABC-120",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "Form up your name and eat them!",
  },
  {
    name: "Butter Murukku Crackers",
    sku: "CRA-BMU-120",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "Classic dal snack",
  },
  {
    name: "ROL-CHO-120",
    sku: "ROL-CHO-GIFT",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "Take a puff and bite.",
  },
  {
    name: "Coin Egg Biscuits",
    sku: "BIS-EGG-RET",
    popular: false,
    weight: 100,
    unit: "g",
    tooltip: "It is hard to resist taking a bite.",
  },
  {
    name: "Butterfly Ear Biscuits",
    sku: "BIS-EAR-120",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "Don't pull your ear, eat some ear biscuits.",
  },
  {
    name: "Shredded Tapioca Fries",
    sku: "TAP-FRI-120",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "Must try if you like fries.",
  },
];

const popularSnackOptionsParty = [
  {
    name: "Berry Nutty Medley",
    sku: "MIX-BRN-PARTY",
    popular: true,
    weight: 20,
    unit: "g",
    tooltip: "Baked cashews, almonds, mulberries, raisins, cranberries",
  },
  {
    name: "Oishi Japanese Nuts Medley",
    sku: "MIX-JAP-PARTY",
    popular: true,
    weight: 15,
    unit: "g",
    tooltip: "Mix of coated peanuts",
  },
  {
    name: "Ruby Cranberries",
    sku: "CRA-DRI-PARTY",
    popular: true,
    weight: 20,
    unit: "g",
    tooltip: "Tangy taste that you can't stop eating!",
  },
  {
    name: "Sweet Mustard Soya Crisps",
    sku: "SOY-SMT-PARTY",
    popular: true,
    weight: 15,
    unit: "g",
    tooltip: "Addictive sweet,complex, tangy flavour",
  },
  {
    name: "Aloha Medley",
    sku: "MIX-ALO-PARTY",
    popular: false,
    weight: 15,
    unit: "g",
    tooltip: "Tropical fruits paradise!",
  },
  {
    name: "Crunchy Medley",
    sku: "MIX-CRU-PARTY",
    popular: false,
    weight: 20,
    unit: "g",
    tooltip: "Roasted cashews, baked almonds, walnuts",
  },
  {
    name: "Kacang Puteh Medley",
    sku: "MIX-KAP-PARTY",
    popular: false,
    weight: 20,
    unit: "g",
    tooltip: "The classic mix that everyone knows",
  },
  {
    name: "Chocolate Ribbon Pretzels",
    sku: "PRE-CHO-PARTY",
    popular: false,
    weight: 15,
    unit: "g",
    tooltip: "Chocolate with the saltiness of pretzels makes a perfect match.",
  },
  {
    name: "Jungle Medley",
    sku: "MIX-JUN-PARTY",
    popular: false,
    weight: 20,
    unit: "g",
    tooltip: "If you are ever stuck in a jungle, these are your friends",
  },
  {
    name: "Super Berries Medley",
    sku: "MIX-BER-PARTY",
    popular: false,
    weight: 20,
    unit: "g",
    tooltip: "Cranberries, goji berries, raisins, cherries",
  },
  {
    name: "Sour Candies Medley",
    sku: "MIX-CAN-PARTY",
    popular: false,
    weight: 20,
    unit: "g",
    tooltip: "To cure your sweet tooth.",
  },
  {
    name: "Summer Fruits Medley",
    sku: "MIX-SMF-PARTY",
    popular: false,
    weight: 20,
    unit: "g",
    tooltip: "Raisins, apricots, banana chips",
  },
];

const popularSnackOptionsGift = [
  {
    name: "Berry Nutty Medley",
    sku: "MIX-BRN-GIFT",
    popular: true,
    weight: 60,
    unit: "g",
    tooltip: "Baked cashews, almonds, mulberries, raisins, cranberries",
  },
  {
    name: "Oishi Japanese Nuts Medley",
    sku: "MIX-JAP-GIFT",
    popular: true,
    weight: 60,
    unit: "g",
    tooltip: "Mix of coated peanuts",
    selected: true,
  },
  {
    name: "Ruby Cranberries",
    sku: "CRA-DRI-GIFT",
    popular: true,
    weight: 60,
    unit: "g",
    tooltip: "Tangy taste that you can't stop eating!",
  },
  {
    name: "Sweet Mustard Soya Crisps",
    sku: "SOY-SMT-GIFT",
    popular: true,
    weight: 60,
    unit: "g",
    tooltip: "Addictive sweet,complex, tangy flavour",
    selected: true,
  },
  {
    name: "Aloha Medley",
    sku: "MIX-ALO-GIFT",
    popular: false,
    weight: 60,
    unit: "g",
    tooltip: "Tropical fruits paradise!",
  },
  {
    name: "Crunchy Medley",
    sku: "MIX-CRU-GIFT",
    popular: false,
    weight: 60,
    unit: "g",
    tooltip: "Roasted cashews, baked almonds, walnuts",
  },
  {
    name: "Kacang Puteh Medley",
    sku: "MIX-KAP-GIFT",
    popular: false,
    weight: 60,
    unit: "g",
    tooltip: "The classic mix that everyone knows",
  },
  {
    name: "Chocolate Ribbon Pretzels",
    sku: "PRE-CHO-GIFT",
    popular: false,
    weight: 60,
    unit: "g",
    tooltip: "Chocolate with the saltiness of pretzels makes a perfect match.",
  },
  {
    name: "Jungle Medley",
    sku: "MIX-JUN-GIFT",
    popular: false,
    weight: 60,
    unit: "g",
    tooltip: "If you are ever stuck in a jungle, these are your friends",
  },
  {
    name: "Super Berries Medley",
    sku: "MIX-BER-GIFT",
    popular: false,
    weight: 60,
    unit: "g",
    tooltip: "Cranberries, goji berries, raisins, cherries",
  },
  {
    name: "Sour Candies Medley",
    sku: "MIX-CAN-GIFT-L",
    popular: false,
    weight: 60,
    unit: "g",
    tooltip: "To cure your sweet tooth.",
  },
  {
    name: "Summer Fruits Medley",
    sku: "MIX-SMF-GIFT",
    popular: false,
    weight: 60,
    unit: "g",
    tooltip: "Raisins, apricots, banana chips",
  },
];

const popularSnackOptionsRetail = [
  {
    name: "Aloha Medley",
    sku: "MIX-ALO-200",
    popular: false,
    weight: 200,
    unit: "g",
    tooltip: "Tropical fruits paradise!",
  },
  {
    name: "Jungle Medley",
    sku: "MIX-JUN-RET",
    popular: false,
    weight: 200,
    unit: "g",
    tooltip: "If you are ever stuck in a jungle, these are your friends",
  },
  {
    name: "Berry Nutty Medley",
    sku: "MIX-BRN-200",
    popular: true,
    weight: 200,
    unit: "g",
    tooltip: "Baked cashews, almonds, mulberries, raisins, cranberries",
  },
  { name: "Ruby Cranberries", sku: "CRA-DRI-200", popular: true, weight: 200, unit: "g", tooltip: "Tangy taste that you can't stop eating!" },
  {
    name: "Oishi Japanese Nuts",
    sku: "MIX-JAP-150",
    popular: true,
    weight: 150,
    unit: "g",
    tooltip: "Mix of coated peanuts",
  },
  {
    name: "Sweet Mustard Soya Crisps",
    sku: "SOY-SMT-150",
    popular: true,
    weight: 150,
    unit: "g",
    tooltip: "Addictive sweet,complex, tangy flavour",
  },
  {
    name: "Chocolate Ribbon Pretzels",
    sku: "PRE-CHO-150",
    popular: false,
    weight: 150,
    unit: "g",
    tooltip: "Chocolate with the saltiness of pretzels makes a perfect match.",
  },
  {
    name: "Peanut Butter Shell Pretzels",
    sku: "PRE-PBS-150",
    popular: false,
    weight: 150,
    unit: "g",
    tooltip: "Something special as a gift.",
  },
  {
    name: "Super Berries Medley",
    sku: "MIX-BER-200",
    popular: false,
    weight: 200,
    unit: "g",
    tooltip: "Cranberries, goji berries, raisins, cherries",
  },
];

const cookieOptionsParty = [
  {
    name: "Dahlia Butter Cookies",
    sku: "COO-BUT-PARTY",
    weight: 15,
    unit: "g",
    tooltip: "Classic butter cookies.",
    popular: true,
  },
  {
    name: "Worthy Pecans Chocolate Chip Cookies (2 pieces)",
    sku: "WOR-PEC-PARTY",
    weight: 12,
    unit: "g",
    tooltip: "Who doesn't like chocolate chips? And the pecans balance the sweetness.",
    popular: true,
  },
  {
    name: "Worthy Kopi Toast Cookies (2 pieces)",
    sku: "WOR-COF-PARTY",
    weight: 12,
    unit: "g",
    tooltip: "Legit Kopi Cookie",
    popular: true,
  },
  {
    name: "Worthy Ondeh Ondeh Cookies (2 cookies)",
    sku: "WOR-OND-PARTY",
    weight: 12,
    unit: "g",
    tooltip: "Coconut, gula melaka and pandan proves a deadly combi.",
    popular: true,
  },
  {
    name: "Worthy Macadamia Cookies (1 cookie)",
    sku: "WOR-MACCOO-PARTY",
    weight: 9,
    unit: "g",
    tooltip: "The macadamia pieces add an extra dimension.",
  },
  {
    name: "Worthy Pistachio Berry Biscotti (3 pieces)",
    sku: "WOR-PIBBIS-PARTY",
    weight: 12,
    unit: "g",
    tooltip: "This. Is. Good.",
  },
  {
    name: "Worthy Almond Biscotti (4 pieces)",
    sku: "WOR-ALMBIS-PARTY",
    weight: 12,
    unit: "g",
    tooltip: "Munching this reminded me that I eat healthy.",
  },
  {
    name: "Worthy Laksa Cookies (2 cookies)",
    sku: "WOR-LAK-PARTY",
    weight: 10,
    unit: "g",
    tooltip: "A fusion of sambal with coconut milk makes it special.",
  },
  {
    name: "Merlion Butter Cookies",
    sku: "COO-MER-PARTY",
    weight: 15,
    unit: "g",
    tooltip: "Eating this reminds me of Home.",
  },
  {
    name: "Chunky Peanut Cookies",
    sku: "COO-PEA-PARTY",
    weight: 20,
    unit: "g",
    tooltip: "Old school peanut cookies.",
  },
  {
    name: "Pandan Bangkit Cookies",
    sku: "COO-PAN-PARTY",
    weight: 15,
    unit: "g",
    tooltip: "A taste of tradition, with refreshing pandan flavour.",
  },
  {
    name: "Worthy Gula Melaka Walnut Cookies",
    sku: "WOR-GMWCOO-PARTY",
    weight: 9,
    unit: "g",
    tooltip: "This is so nice!",
  },
];

const cookieOptionsGift = [
  {
    name: "Dahlia Butter Cookies",
    sku: "COO-BUT-GIFT",
    weight: 50,
    unit: "g",
    tooltip: "Classic butter cookies.",
    popular: true,
  },
  { 
    name: "Worthy Pecans Chocolate Chip Cookies (7 pieces)",
    sku: "WOR-PEC-GIFT",
    weight: 40,
    unit: "g",
    tooltip: "Who doesn't like chocolate chips? And the pecans balance the sweetness.",
    popular: true,
  },
  {
    name: "Worthy Kopi Toast Cookies (7 pieces)",
    sku: "WOR-COF-GIFT",
    weight: 40,
    unit: "g",
    tooltip: "Legit Kopi Cookie",
    popular: true,
  },
  {
    name: "Worthy Ondeh Ondeh Cookies (7 cookies)",
    sku: "WOR-OND-GIFT",
    weight: 40,
    unit: "g",
    tooltip: "Coconut, gula melaka and pandan proves a deadly combi.",
    popular: true,
  },
  {
    name: "Worthy Macadamia Cookies (5 cookies)",
    sku: "WOR-MACCOO-GIFT",
    weight: 40,
    unit: "g",
    tooltip: "The macadamia pieces add an extra dimension.",
  },
  {
    name: "Worthy Pistachio Berry Biscotti (10 pieces)",
    sku: "WOR-PIBBIS-GIFT",
    weight: 40,
    unit: "g",
    tooltip: "This. Is. Good.",
    popular: true,
  },
  {
    name: "Worthy Almond Biscotti (10 pieces)",
    sku: "WOR-ALMBIS-GIFT",
    weight: 40,
    unit: "g",
    tooltip: "Munching this reminded me that I eat healthy.",
  },
  {
    name: "Worthy Laksa Cookies (7 cookies)",
    sku: "WOR-LAK-GIFT",
    weight: 40,
    unit: "g",
    tooltip: "A fusion of sambal with coconut milk makes it special.",
  },
  {
    name: "Merlion Butter Cookies",
    sku: "COO-MER-GIFT",
    weight: 50,
    unit: "g",
    tooltip: "Eating this reminds me of Home.",
  },
  {
    name: "Pandan Bangkit Cookies",
    sku: "COO-PAN-GIFT",
    weight: 50,
    unit: "g",
    tooltip: "A taste of tradition, with refreshing pandan flavour.",
  },
  {
    name: "Chunky Peanut Cookies",
    sku: "COO-PEA-GIFT",
    weight: 50,
    unit: "g",
    tooltip: "Old school peanut cookies.",
  },
  {
    name: "Worthy Gula Melaka Walnut Cookies",
    sku: "WOR-GMWCOO-GIFT",
    weight: 40,
    unit: "g",
    tooltip: "Sweet and fragrant!",
  },
];

const goodieBoxOptions = [
  {"name": "Antioxidants Medley", "sku": "GBOX-MIX-ANT", "weight": 150, "unit": "g"},
  {"name": "Oishi Japanese Nuts", "sku": "GBOX-MIX-JAP", "weight": 100, "unit": "g"},
  {"name": "Pandan Bangkit Cookies", "sku": "GBOX-COO-PAN", "weight": 100, "unit": "g"},
  {"name": "Dahlia Butter Cookies", "sku": "GBOX-COO-BUT", "weight": 100, "unit": "g"},
  {"name": "Seedy Trail Medley", "sku": "GBOX-MIX-TRA", "weight": 150, "unit": "g"},
  {"name": "Berry Nutty Medley", "sku": "GBOX-MIX-BRN", "weight": 150, "unit": "g"},
  {"name": "Fantasy Candies Medley", "sku": "GBOX-MIX-FAN", "weight": 150, "unit": "g"},
  {"name": "Fluffy Strawberry Candies", "sku": "GBOX-CAN-FLU", "weight": 100, "unit": "g"},
];

const snackieBoxOptions = [
{"name": "Worthy Kopi Toast Cookies", "sku": "SBOX-WOR-COF", "weight": 150, "unit": "g"},
{"name": "Worthy Macadamia Cookies", "sku": "SBOX-WOR-MAC", "weight": 150, "unit": "g"},
{"name": "Worthy Ondeh Ondeh Cookies", "sku": "SBOX-WOR-OND", "weight": 150, "unit": "g"},
{"name": "Worthy Pecans Chocolate Chip Cookies", "sku": "SBOX-WOR-PEC", "weight": 150, "unit": "g"},
{"name": "Worthy Laksa Cookies", "sku": "WOR-LAK-RET", "weight": 120, "unit": "g"},
{"name": "Chocolate Pretzels Almonds", "sku": "SBOX-MIX-CHOC", "weight": 150, "unit": "g"},
{"name": "Fruity Veggie Medley", "sku": "SBOX-MIX-FTV", "weight": 120, "unit": "g"},
{"name": "Sweet Mustard Honey Macadamias", "sku": "SBOX-MIX-SWEET", "weight": 150, "unit": "g"},
];

const premiumSnackieBoxOptions = [
{"name": "Honey Brainy Pecans", "sku": "SBOX-PEC-HON", "weight": 220, "unit": "g"},
{"name": "Abalone Creamy Macadamia", "sku": "SBOX-MAC-ABA", "weight": 220, "unit": "g"},
{"name": "Power Baked Pistachio Kernels", "sku": "SBOX-PIK-BAK", "weight": 250, "unit": "g"},
{"name": "Xmas Pine Nuts", "sku": "SBOX-PIN-RAW", "weight": 250, "unit": "g"},
];

const xmasSnackieOptions = [
{"name": "Chocolate Pretzels Almonds", "sku": "SBOX-MIX-CHOC", "weight": 250, "unit": "g"},
{"name": "Sweet Mustard Honey Macadamias", "sku": "SBOX-MIX-SWEET", "weight": 200, "unit": "g"},
{"name": "Worthy Kopi Toast Cookies", "sku": "SBOX-WOR-COF-FESTIVE", "weight": 150, "unit": "g"},
{"name": "Worthy Macadamia Cookies", "sku": "SBOX-WOR-MAC-FESTIVE", "weight": 150, "unit": "g"},
{"name": "Worthy Ondeh Ondeh Cookies", "sku": "SBOX-WOR-OND-FESTIVE", "weight": 150, "unit": "g"},
{"name": "Worthy Pecans Chocolate Chip Cookies", "sku": "SBOX-WOR-PEC-FESTIVE", "weight": 150, "unit": "g"},
];

const cutieBoxOptions = [
  { name: "Diamond Baked Almonds", sku: "CBOX-ALM-BAK", weight: 70, unit: "g" },
  { name: "Strawberry Yoghurt Candies", sku: "CBOX-CAN-YOG", weight: 120, unit: "g" },
  { name: "Smiley Baked Cashews", sku: "CBOX-CAS-BAK", weight: 70, unit: "g" },
  { name: "Nihon Seaweed Peanuts", sku: "CBOX-PEA-NIS", weight: 40, unit: "g" },
  { name: "Kacang Puteh Medley", sku: "CBOX-MIX-KAP", weight: 60, unit: "g" },
  { name: "Sour Candies Medley", sku: "CBOX-MIX-CAN", weight: 100, unit: "g" },
  { name: "Butter Murukku Crackers", sku: "CBOX-CRA-BMU", weight: 40, unit: "g" },
  { name: "Nostalgic Iced Gem", sku: "CBOX-ICG-TRA", weight: 40, unit: "g" },
];

const hamperRetailPackOptions = [
{"name": "Crisp Crack Medley", "sku": "MIX-CRI-RET", "weight": 150, "unit": "g"},
{"name": "Jungle Medley", "sku": "MIX-JUN-RET", "weight": 200, "unit": "g"},
{"name": "Berry Nutty Medley", "sku": "MIX-BRN-200", "weight": 200, "unit": "g"},
{"name": "Oishi Japanese Nuts Medley", "sku": "MIX-JAP-150", "weight": 150, "unit": "g"},
{"name": "Sweet Mustard Soya Crisps", "sku": "SOY-SMT-150", "weight": 150, "unit": "g"},
{"name": "Chocolate Ribbon Pretzels", "sku": "PRE-CHO-150", "weight": 150, "unit": "g"},
{"name": "Peanut Butter Shell Pretzels", "sku": "PRE-PBS-150", "weight": 150, "unit": "g"},
{"name": "Super Berries Medley", "sku": "MIX-BER-200", "weight": 200, "unit": "g"},
]

const remedyOptions = [
  // {
  //   name: "Remedy - Mango Passion Kombucha",
  //   sku: "REM-MANPAS-250",
  //   popular: false,
  //   weight: 250,
  //   unit: "ml",
  //   tooltip: "",
  // },
  // { name: "Remedy - Wild Berry Kombucha", sku: "REM-WILBER-250", popular: false, weight: 250, unit: "ml", tooltip: "" },
  // {
  //   name: "Remedy - Raspberry Lemonade Kombucha",
  //   sku: "REM-RASLEM-250",
  //   popular: true,
  //   weight: 250,
  //   unit: "ml",
  //   tooltip: "",
  // },
  // {
  //   name: "Remedy - Orange Squeeze Kombucha",
  //   sku: "REM-ORASQU-250",
  //   popular: true,
  //   weight: 250,
  //   unit: "ml",
  //   tooltip: "",
  // },
];

const gryphonOptions = [
  {
    name: "Gryphon - Chamomile Dream with Apple",
    sku: "GRY-CDA-300",
    popular: false,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
  {
    name: "Gryphon - Earl Grey Lavender Tea with Strawberry",
    sku: "GRY-EGS-300",
    popular: false,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
  {
    name: "Gryphon - Hanami with White Peach",
    sku: "GRY-HAN-300",
    popular: false,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
  {
    name: "Gryphon - Osmanthus Sencha with Passionfruit",
    sku: "GRY-OSP-300",
    popular: false,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
  {
    name: "Gryphon - Pearl of the Orient with Lychee",
    sku: "GRY-POL-300",
    popular: true,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
];

const dashOptions = [
  { name: "Dash - Cucumber Sparkling Water", sku: "DAS-CUC-300", popular: false, weight: 300, unit: "ml", tooltip: "" },
  { name: "Dash - Lime Sparkling Water", sku: "DAS-LIM-300", popular: false, weight: 300, unit: "ml", tooltip: "" },
  { name: "Dash - Peach Sparkling Water", sku: "DAS-PEA-300", popular: true, weight: 300, unit: "ml", tooltip: "" },
  {
    name: "Dash - Raspberry Sparkling Water",
    sku: "DAS-RAS-300",
    popular: false,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
];

const sodalyOptions = [
  {
    name: "Sodaly - Yuzu Lemon Prebiotic Soda",
    sku: "SOD-YUZ-250",
    popular: false,
    weight: 250,
    unit: "ml",
    tooltip: "",
  },
  { name: "Sodaly - Guava Prebiotic Soda", sku: "SOD-GUA-250", popular: false, weight: 250, unit: "ml", tooltip: "" },
  {
    name: "Sodaly - Passionfruit Prebiotic Soda",
    sku: "SOD-PAS-250",
    popular: false,
    weight: 250,
    unit: "ml",
    tooltip: "",
  },
  {
    name: "Sodaly - Lemon Lime Bitters Prebiotic Soda",
    sku: "SOD-LEM-250",
    popular: false,
    weight: 250,
    unit: "ml",
    tooltip: "",
  },
];

const healthyDrinkOptions = remedyOptions.concat(gryphonOptions).concat(dashOptions).concat(sodalyOptions); 

const surpriseMe = [
  { name: "Surprise Me!", sku: "SURPRISE-DRINK-", popular: false, unit: "ml", tooltip: "Randomness is beauty" },
];

const rudeHealthOptions = [
  {
    name: "Rude Health - Ultimate Almond Drink",
    sku: "RUH-ULTALM-1K",
    popular: true,
    weight: 1,
    unit: "L",
    tooltip: "",
  },
  {
    name: "Rude Health - Organic Almond Drink",
    sku: "RUH-ORGALM-1K",
    popular: false,
    weight: 1,
    unit: "L",
    tooltip: "",
  },
  {
    name: "Rude Health - Organic Cashew Drink",
    sku: "RUH-ORGCAS-1K",
    popular: false,
    weight: 1,
    unit: "L",
    tooltip: "",
  },
  {
    name: "Rude Health - Organic Coconut Drink",
    sku: "RUH-ORGCOC-1K",
    popular: false,
    weight: 1,
    unit: "L",
    tooltip: "",
  },
  {
    name: "Rude Health - Organic Hazelnut Drink",
    sku: "RUH-ORGHAZ-1K",
    popular: false,
    weight: 1,
    unit: "L",
    tooltip: "",
  },
];

const mooncakeFlavours = [
  { name: "Macadamia With Lotus Paste", sku: "MNC-MAC-170", weight: 170, unit: "g" },
  { name: "Mixed Nuts With Chicken Ham", sku: "MNC-MXN-170", weight: 170, unit: "g", popular: true },
  { name: "Double Yolk With Lotus Paste", sku: "MNC-DBY-170", weight: 170, unit: "g", popular: true },
  { name: "White Coffee with Melon Seeds", sku: "MNC-COF-170", weight: 170, unit: "g" },
];

const deepavaliSnacksRetail = [
  { name: "Butter Murukku Crackers", sku: "CRA-BMU-120", weight: 120, unit: "g", popular: true },
  { name: "Spicy Murukku Crackers", sku: "CRA-SMU-120", weight: 120, unit: "g" },
  { name: "Star Murukku Crackers", sku: "CRA-STA-RET", weight: 120, unit: "g", popular: true },
  { name: "Aloha Medley", sku: "MIX-ALO-200", weight: 200, unit: "g" },
  { name: "Berry Nutty Medley", sku: "MIX-BRN-200", weight: 200, unit: "g", popular: true },
  { name: "Crunchy Medley", sku: "MIX-CRU-200", weight: 200, unit: "g" },
  { name: "Fantasy Medley", sku: "MIX-FAN-200", weight: 200, unit: "g" },
  { name: "Juicy Apricots", sku: "APR-DRI-200", weight: 200, unit: "g" },
  { name: "Kacang Puteh Medley", sku: "MIX-KAP-200", weight: 200, unit: "g", popular: true },
  { name: "Rich Chocolate Almonds", sku: "ALM-CHO-200", weight: 200, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-200", weight: 200, unit: "g" },
];

const deepavaliSnacksGift = [
  {
		"sku" : "CRA-BMU-GIFT",
		"name" : "Seasonal: Butter Murukku Crackers",
    unit: "g",
		"weight" : 30
	},
	{
		"sku" : "CRA-PAG-GIFT",
		"name" : "Seasonal: Pagoda Murukku Crackers",
    unit: "g",
		"weight" : 30
	},
	{
		"sku" : "CRA-SMU-GIFT",
		"name" : "Seasonal: Spicy Murukku Crackers",
    unit: "g",
		"weight" : 30
	},
	{
		"sku" : "CRA-STA-GIFT",
		"name" : "Seasonal: Star Murukku Crackers",
    unit: "g",
		"weight" : 30
	},
].concat(popularSnackOptionsGift);

const deepavaliSnacksParty = [
  { name: "Butter Murukku Crackers", sku: "CRA-BMU-10", weight: 10, unit: "g", popular: true },
  { name: "Spicy Murukku Crackers", sku: "CRA-SMU-10", weight: 10, unit: "g" },
  { name: "Star Murukku Crackers", sku: "CRA-STA-PARTY", weight: 10, unit: "g", popular: true },
  { name: "Aloha Medley", sku: "MIX-ALO-20", weight: 15, unit: "g" },
  { name: "Berry Nutty Medley", sku: "MIX-BRN-25", weight: 20, unit: "g", popular: true },
  { name: "Crunchy Medley", sku: "MIX-CRU-25", weight: 20, unit: "g" },
  { name: "Fantasy Medley", sku: "MIX-FAN-25", weight: 20, unit: "g" },
  { name: "Juicy Apricots", sku: "APR-DRI-25", weight: 20, unit: "g" },
  { name: "Kacang Puteh Medley", sku: "MIX-KAP-25", weight: 20, unit: "g", popular: true },
  { name: "Rich Chocolate Almonds", sku: "ALM-CHO-25", weight: 20, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-25", weight: 20, unit: "g" },
];

const hariRayaSpecials = [
  { name: "Colourful Donut Cookies", sku: "RAYA-COO-DON", weight: 300, unit: "g", popular: false },
  { name: "Lazat Cornflake Cookies", sku: "RAYA-COO-COR", weight: 400, unit: "g", popular: false },
  { name: "Pandan Makmur Cookies", sku: "RAYA-PMAK-300", weight: 300, unit: "g", popular: true },
  { name: "Pandan Pineapple Tarts", sku: "RAYA-PPIN-300", weight: 300, unit: "g", popular: true },
];

const hariRayaSnacks200 = [
  { name: "Bushy Mulberries", sku: "MUL-DRI-200", weight: 200, unit: "g" },
  { name: "Crunchy Medley", sku: "MIX-CRU-200", weight: 200, unit: "g", popular: true },
  { name: "Honey Red Dates", sku: "DAT-HON-200", weight: 200, unit: "g", popular: true },
  { name: "Go Big Natural Figs", sku: "FIG-TNA-200", weight: 200, unit: "g", popular: true },
  { name: "Juicy Apricots", sku: "APR-DRI-200", weight: 200, unit: "g", popular: true },
  { name: "Kacang Puteh Medley", sku: "MIX-KAP-200", weight: 200, unit: "g" },
  { name: "Nihon Seaweed Peanuts", sku: "PEA-NIS-200", weight: 200, unit: "g" },
  { name: "Nostalgic Iced Gem", sku: "ICG-TRA-120", weight: 120, unit: "g" },
  { name: "Organic Cinnamon Granola", sku: "GRA-OCI-150", weight: 150, unit: "g" },
  { name: "Satay Wasabi Peanuts", sku: "PEA-SWS-200", weight: 200, unit: "g" },
  { name: "Smiley Baked Cashews", sku: "CAS-BAK-200", weight: 200, unit: "g" },
  { name: "Sunshine Jumbo Raisins", sku: "RAI-YELJ-200", weight: 200, unit: "g" },
];

const wedingPartyPacksOptions = [
  { name: "Chocolate Ribbon Pretzels", sku: "PRE-CHO-PARTY", weight: 15, unit: "g", popular: true },
  { name: "Berry Nutty Chewy Nougats", sku: "CNO-BRN-PARTY", weight: 20, unit: "g", popular: true },
  { name: "Worthy Pecans Chocolate Chip Cookies", sku: "WOR-PEC-PARTY", weight: 12, unit: "g", popular: true },
  { name: "Sweet Mustard Soya Crisps", sku: "SOY-SMT-PARTY", weight: 15, unit: "g", popular: true },
  { name: "Oishi Japanese Nuts Medley", sku: "MIX-JAP-PARTY", weight: 15, unit: "g"},
  { name: "Pistachio Strawberry Granola", sku: "GRA-PIS-PARTY", weight: 20, unit: "g" },
  { name: "Rich Chocolate Almonds", sku: "ALM-CHO-PARTY", weight: 20, unit: "g" },
  { name: "Berry Nutty Medley", sku: "MIX-BRN-PARTY", weight: 20, unit: "g" },
  { name: "Dahlia Butter Cookies", sku: "COO-BUT-PARTY", weight: 15, unit: "g" },
  { name: "Worthy Macadamia Cookies", sku: "WOR-MACCOO-PARTY", weight: 9, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-PARTY", weight: 20, unit: "g" },
  { name: "Summer Fruits Medley", sku: "MIX-SMF-PARTY", weight: 20, unit: "g" },
];

const snackConeOptions = [
  { name: "Kacang Puteh Medley", sku: "CONE-MIX-KAP", weight: 70, unit: "g" },
  { name: "Magical Jellybeans Candies", sku: "CONE-CAN-MAG", weight: 70, unit: "g" },
  { name: "Oishi Japanese Nuts Medley", sku: "CONE-MIX-JAP", weight: 40, unit: "g" },
  { name: "Sour Candies Medley", sku: "CONE-MIX-CAN", weight: 70, unit: "g" },
  { name: "Sweet Mustard Soya Crisps", sku: "CONE-SOY-SMT", weight: 40, unit: "g" },
];

const customMedleyOptions = [
  { name: "Smiley Baked Almonds", isHalfPortion: false, unit: "g" },
  { name: "Smiley Baked Cashew", isHalfPortion: false, unit: "g" },
  { name: "Sunkissed Roasted Cashew", isHalfPortion: false, unit: "g" },
  { name: "Squirrel Baked Walnuts", isHalfPortion: false, unit: "g" },
  { name: "Chocolatey Baked Hazelnuts", isHalfPortion: false, unit: "g" },
  { name: "Brainy Baked Pecans", isHalfPortion: false, unit: "g" },
  { name: "Ruby Cranberries", isHalfPortion: false, unit: "g" },
  { name: "Midnight Black Raisins", isHalfPortion: false, unit: "g" },
  { name: "Jumbo Yellow Raisins", isHalfPortion: false, unit: "g" },
  { name: "Honey Deglet Nour Dates", isHalfPortion: false, unit: "g" },
  { name: "Jewel Medjool Dates", isHalfPortion: false, unit: "g" },
  { name: "Go Big Natural Figs", isHalfPortion: false, unit: "g" },
  { name: "Superfruit Blackcurrants", isHalfPortion: false, unit: "g" },
  { name: "Organic Copra Coconut Chips", isHalfPortion: false, unit: "g" },
  { name: "Organic Bushy Mulberries", isHalfPortion: false, unit: "g" },  
  { name: "Summer Blueberries", isHalfPortion: false, unit: "g" },
  { name: "Organic Baked Halloween Pumpkin Seeds", isHalfPortion: false, unit: "g" },
  { name: "Organic Stunning Sunflower Seeds", isHalfPortion: false, unit: "g" },
  { name: "Garbanzo Chickpeas", isHalfPortion: false, unit: "g" },
  { name: "Shadow Black Beans", isHalfPortion: false, unit: "g" },
  { name: "Organic Fantastic Flax Seeds", isHalfPortion: false, unit: "g" },
  { name: "Baked Pistachio Kernels (Premium half portion)", isHalfPortion: true, unit: "g" },
  { name: "Baked Macadamia (Halves) (Premium half portion)", isHalfPortion: true, unit: "g" },
  { name: "Baked Brazil Nuts (Premium half portion)", isHalfPortion: true, unit: "g" },
  { name: "Raw Pine Nuts (Premium half portion)", isHalfPortion: true, unit: "g" },
];

const popularDrinkOptions = remedyOptions
  .concat(gryphonOptions)
  .concat(dashOptions)
  .concat(sodalyOptions)
  .concat(surpriseMe);

const yesOrNo = [
  { name: "Yes", sku: "yes" },
  { name: "No", sku: "no" },
];

const icedGemKeyChainOptions = [
  { name: "Blue Iced Gem Keychain", sku: "SF-GEM-BKEY" },
  { name: "Pink Iced Gem Keychain", sku: "SF-GEM-PKEY" },
];

const bearBottleOptions = [
  { name: "Magical Jellybeans Candies in Blue Bear Bottle", sku: "BEAR-CAN-MAG" },
  { name: "Sweet Peach Candies in Pink Bear bottle", sku: "BEAR-CAN-SWP" },
];

const imageOptionsParty = [
  {
    name: "Deepavali26-A",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Deepavali_Label_A_4.5x2.2.webp?v=1791857293",
  },
  {
    name: "Deepavali26-B",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Deepavali_Label_B_4.5x2.2.webp?v=1791857294",
  },
  {
    name: "Deepavali26-C",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Deepavali_Label_C_4.5x2.2.webp?v=1791857293",
  },
  {
    name: "Deepavali26-D",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Deepavali_Label_D_4.5x2.2.webp?v=1791857293",
  },
  {
    name: "Happy Snacking Red",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Party_-_Happy_Snacking_Red.webp?v=1791363625",
  },
  {
    name: "Happy Snacking Emoji",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Party_-_Happy_Snacking_Emoji.webp?v=1791363626",
  },
  {
    name: "Happy Snacking Almond",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Party_-_Happy_Snacking_Almond.webp?v=1791365490",
  },
  {
    name: "Thank You Gift",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Party_-_Thank_You_Gift.webp?v=1791363626",
  },
  {
    name: "Thank You Floral",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Party_-_Thank_You_Floral.webp?v=1791365490",
  },
  {
    name: "Little Treat",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Party_-_Little_treat.webp?v=1791363626",
  },
];

const imageOptions = [
  {
    name: "Deepavali26-A",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/deepavali2026-a.webp?v=1788945073",
  },
  {
    name: "Deepavali26-B",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/deepavali2026-b.webp?v=1788945073",
  },
  {
    name: "Deepavali26-C",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/deepavali2026-c.webp?v=1788945072",
  },
  {
    name: "Deepavali26-D",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/deepavali2026-d.webp?v=1788945073",
  },
  {
    name: "Happy Snacking Red",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Gift_-_Happy_Snacking_Red_-5545.webp?v=1791365490",
  },
  {
    name: "Happy Snacking Emoji",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Gift_-_Happy_Snacking_Emoji_-5545.webp?v=1791365490",
  },
  {
    name: "Happy Snacking Almond",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Gift_-_Happy_Snacking_Almond_-5545.webp?v=1791365489",
  },
  {
    name: "Thank You Gift",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Gift_-_Thank_You_Gift_-5545.webp?v=1791365490",
  },
  {
    name: "Thank You Floral",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Gift_-_Thank_You_Floral_-5545.webp?v=1791365490",
  },
  {
    name: "Little Treat",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Gift_-_Little_treat_-5545.webp?v=1791365490",
  },
  {
    name: "Standard",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Standard_Party_Gift_Labels.webp?v=1783776093",
  },
];

const weddingImageOptions = [
  {
    name: "Thank you",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/thank-you-for-celebrating-with-us.png?v=1694483708",
  },
  {
    name: "Pink",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Pink.webp?v=1778839932",
  },
  {
    name: "Peach",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Peach.webp?v=1778839932",
  },
  {
    name: "Red Traditional",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Red_Traditional.webp?v=1778839932",
  },
  {
    name: "Our Wedding Day",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Our_Wedding_Day.webp?v=1778839932",
  },
  {
    name: "Golden Leaves",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Golden_Leaves.webp?v=1778839933",
  },
]

const hamperStickerOptions = [
  { name: "Design A", sku: "HAM-DESIGN-A" },
  { name: "Design B", sku: "HAM-DESIGN-B" },
  { name: "Design C", sku: "HAM-DESIGN-C" },
  { name: "Design D", sku: "HAM-DESIGN-D" },
  { name: "Plain (No Design)", sku: "HAM-DESIGN-PLAIN" },
];

const teaPartyPackOptions = [
  {
    name: "Citrus Bloom - Kumquat Oolong Tea",
    sku: "TEA-CITRUS-SPP",
    popular: true,
    weight: 2,
    unit: "g",
    tooltip: "Refreshiung orange zest.",
  },
  {
    name: "Velvet Bloom - Rose Earl Grey Black Tea",
    sku: "TEA-VELVET-SPP",
    popular: true,
    weight: 2,
    unit: "g",
    tooltip: "Fragrant and bold taste.",
  },
  {
    name: "Gentle Bloom - Lychee Jasmine Green Tea",
    sku: "TEA-GENTLE-SPP",
    popular: false,
    weight: 2,
    unit: "g",
    tooltip: "Soothing and calming.",
  },
  {
    name: "Pure Bloom - Apple Lemongrass Detox Tea",
    sku: "TEA-PURE-SPP",
    popular: false,
    weight: 2,
    unit: "g",
    tooltip: "A weekly detox makes a weekend fulfilled.",
  },
];

const teaPouchOptions = [
  {
    name: "Citrus Bloom - Kumquat Oolong Tea",
    sku: "TEA-CITRUS-POU",
    popular: true,
    tooltip: "Refreshiung orange zest.",
  },
  {
    name: "Velvet Bloom - Rose Earl Grey Black Tea",
    sku: "TEA-VELVET-POU",
    popular: true,
    tooltip: "Fragrant and bold taste.",
  },
  {
    name: "Gentle Bloom - Lychee Jasmine Green Tea",
    sku: "TEA-GENTLE-POU",
    popular: false,
    tooltip: "Soothing and calming.",
  },
  {
    name: "Pure Bloom - Apple Lemongrass Detox Tea",
    sku: "TEA-PURE-POU",
    popular: false,
    tooltip: "A weekly detox makes a weekend fulfilled.",
  },
];

const honeyPartyPackOptions = [
  {
    name: "Multi Floral Honey",
    sku: "HON-MULTI-SAC",
    popular: true,
    weight: 8,
    unit: "g",
    tooltip: "Versatile everyday honey.",
  },
  {
    name: "Red Gum Honey",
    sku: "HON-REDGUN-SAC",
    popular: false,
    weight: 8,
    unit: "g",
    tooltip: "Rich robust bold flavour.",
  },
];

const crystieOptions = [
  {
    name: "Supreme Popular Medley",
    sku: "CRY-MIX-POP",
    popular: true,
    // weight: 120,
    // unit: "g",
    // tooltip: "Refreshiung orange zest.",
  },
  {
    name: "Honey Creamy Macadamias",
    sku: "CRY-MAC-HON",
    popular: true,
    // weight: 2,
    // unit: "g",
    // tooltip: "Fragrant and bold taste.",
  },
  {
    name: "Abalone Creamy Macadamias",
    sku: "CRY-MAC-ABA",
  },
  {
    name: "Xmas Pine Nuts",
    sku: "CRY-PIN-RAW",
  },
  {
    name: "Honey Brainy Pecans",
    sku: "CRY-PEC-HON",
  },
  {
    name: "Power Baked Pistachio Kernels",
    sku: "CRY-PIK-BAK",
  },
  {
    name: "Cocoa Power Medley",
    sku: "CRY-MIX-CPO",
    popular: true,
  },
  {
    name: "Himalayan Rock Salt Walnuts",
    sku: "CRY-MIX-CPO",
  },
];

const bitsieOptions = [
  {
    name: "Organic Almond Butter",
    sku: "BUT-ALM-BITSIE",
  },
  {
    name: "Organic Cashew Butter",
    sku: "BUT-CAS-BITSIE",
  },
  {
    name: "Organic Vegan Kaya",
    sku: "BUT-KAY-BITSIE",
  },
  {
    name: "Organic Hazelnut Cacao Butter",
    sku: "BUT-HAZ-BITSIE",
  },
  {
    name: "Multi Floral Honey",
    sku: "HON-MULTI-BITSIE",
  },
];

const bitsitePremiumOptions = [
  {
    name: "Organic Walnut Butter",
    sku: "BUT-WAL-BITSIE",
  },
  {
    name: "Red Gum Honey",
    sku: "HON-REDGUM-BITSIE",
  },
];

const mtinGoldOptions = [
  {
		"sku" : "MTIN-CRA-BMU",
		"name" : "Butter Murukku Crackers"
	},
	{
		"sku" : "MTIN-PAT-FLO",
		"name" : "Floral Pineapple Tarts"
	},
	{
		"sku" : "MTIN-MIX-FBB",
		"name" : "Flying Burger Balls Medley"
	},
	{
		"sku" : "MTIN-MIX-KAP",
		"name" : "Kacang Puteh Medley"
	},
	{
		"sku" : "MTIN-TAP-NAS",
		"name" : "Nasi Lemak Tapioca Chips"
	},
	{
		"sku" : "MTIN-ICG-TRA",
		"name" : "Nostalgic Iced Gem"
	},
	{
		"sku" : "MTIN-CRA-PAG",
		"name" : "Pagoda Murukku Crackers"
	},
	{
		"sku" : "MTIN-COO-PAN",
		"name" : "Pandan Bangkit Cookies"
	},
	{
		"sku" : "MTIN-ROL-RAI",
		"name" : "Rainbow Strawberry Rolls"
	},
	{
		"sku" : "MTIN-CRA-REM",
		"name" : "Rempeyek Peanut Crackers"
	},
	{
		"sku" : "MTIN-SHP-SAM",
		"name" : "Sambal Shrimp Rolls"
	},
];

const mtinRedOptions = [
	{
		"sku" : "MTIN-COO-MER",
		"name" : "Merlion Butter Cookies"
	},
	{
		"sku" : "MTIN-WOR-ALMBIS",
		"name" : "Worthy Almond Biscotti"
	},
	{
		"sku" : "MTIN-WOR-GMWCOO",
		"name" : "Worthy Gula Melaka Walnut Cookies"
	},
	{
		"sku" : "MTIN-WOR-COF",
		"name" : "Worthy Kopi Toast Cookies"
	},
	{
		"sku" : "MTIN-WOR-LAK",
		"name" : "Worthy Laksa Cookies"
	},
	{
		"sku" : "MTIN-WOR-MAC",
		"name" : "Worthy Macadamia Cookies"
	},
	{
		"sku" : "MTIN-WOR-OND",
		"name" : "Worthy Ondeh Ondeh Cookies"
	},
	{
		"sku" : "MTIN-WOR-PEC",
		"name" : "Worthy Pecans Chocolate Chip Cookies"
	},
	{
		"sku" : "MTIN-WOR-PIBBIS",
		"name" : "Worthy Pistachio Berry Biscotti"
	},
];

const mtinDeepavaliNormal = [
  {
		"sku" : "MTIN-CRA-BMU",
		"name" : "Butter Murukku Crackers"
	},
	{
		"sku" : "MTIN-CRA-PAG",
		"name" : "Pagoda Murukku Crackers"
	},
  {
		"sku" : "MTIN-CRA-STA",
		"name" : "Spicy Murukku Crackers"
	},
	{
		"sku" : "MTIN-CRA-SMU",
		"name" : "Star Murukku Crackers"
	},
];

const mtinDeepavaliGourmet = [
  {
		"sku" : "MTIN-ALM-CHO",
		"name" : "Rich Chocolate Almonds"
	},
	{
		"sku" : "MTIN-WOR-MAC",
		"name" : "Worthy Macadamia Cookies"
	},
  {
		"sku" : "MTIN-WOR-OND",
		"name" : "Worthy Ondeh Ondeh Cookies"
	},
	{
		"sku" : "MTIN-WOR-PISCOO",
		"name" : "Worthy Pistachio Cookies"
	},
];

const biscuitsCandiesPartyOptions = [
  {
		"sku" : "CAN-BEA-PARTY",
		"name" : "Beary Sour Candies",
        weight: 15,
    unit: "g",
	},
  {
    "sku" : "PRE-CHO-PARTY",
    "name" : "Chocolate Ribbon Pretzels",
            weight: 15,
    unit: "g",
  },
  {
		"sku" : "MIX-FAN-PARTY",
		"name" : "Fantasy Candies Medley",
            weight: 20,
    unit: "g",
	},
  {
		"sku" : "CAN-FLU-PARTY",
		"name" : "Fluffy Strawberry Candies",
            weight: 15,
    unit: "g",
	},
  {
    "sku" : "CAN-GUM-PARTY",
    "name" : "Gummi Bear Candies",
            weight: 20,
    unit: "g",
  },
  {
    "sku" : "CAN-MAG-PARTY",
    "name" : "Magical Jellybeans Candies",
            weight: 20,
    unit: "g",
  },
  {
		"sku" : "MIX-CAN-PARTY",
		"name" : "Sour Candies Medley",
            weight: 20,
    unit: "g",
	},
  {
		"sku" : "CAN-YOG-PARTY",
		"name" : "Strawberry Yoghurt Candies",
            weight: 15,
    unit: "g",
	},
];

const biscuitsCandiesGiftOptions = [
  {
		"sku" : "CAN-BEA-GIFT",
		"name" : "Beary Sour Candies",
		"weight" : 50,
		"unit" : "g"
	},
	{
		"sku" : "PRE-CHO-GIFT",
		"name" : "Chocolate Ribbon Pretzels",
		"weight" : 60,
		"unit" : "g"
	},
	{
		"sku" : "MIX-FAN-GIFT",
		"name" : "Fantasy Candies Medley",
		"weight" : 60,
		"unit" : "g"
	},
	{
		"sku" : "CAN-FLU-GIFT",
		"name" : "Fluffy Strawberry Candies",
		"weight" : 50,
		"unit" : "g"
	},
	{
		"sku" : "CAN-GUM-GIFT",
		"name" : "Gummi Bear Candies",
		"weight" : 60,
		"unit" : "g"
	},
	{
		"sku" : "CAN-MAG-GIFT",
		"name" : "Magical Jellybeans Candies",
		"weight" : 60,
		"unit" : "g"
	},
	{
		"sku" : "MIX-CAN-GIFT",
		"name" : "Sour Candies Medley",
		"weight" : 60,
		"unit" : "g"
	},
	{
		"sku" : "CAN-YOG-GIFT",
		"name" : "Strawberry Yoghurt Candies",
		"weight" : 50,
		"unit" : "g"
	}
];

const childrenBiscuitsPartyOptions = [
	{
		"sku" : "BIS-ABC-PARTY",
		"name" : "ABC Alphabet Biscuits",
		"weight" : 10,
		"unit" : "g"
	},
	{
		"sku" : "CRA-BMU-PARTY",
		"name" : "Butter Murukku Crackers",
		"weight" : 10,
		"unit" : "g"
	},
	{
		"sku" : "BIS-EAR-PARTY",
		"name" : "Butterfly Ear Biscuits",
		"weight" : 10,
		"unit" : "g"
	},
	{
		"sku" : "POP-CAR-PARTY",
		"name" : "Caramel Poofy Popcorn",
		"weight" : 5,
		"unit" : "g"
	},
	{
		"sku" : "CRA-PWH-PARTY",
		"name" : "Couch Potato Wheel Crackers",
		"weight" : 2,
		"unit" : "g"
	},
	{
		"sku" : "MIX-FBB-PARTY",
		"name" : "Flying Burger Balls Medley",
		"weight" : 15,
		"unit" : "g"
	},
	{
		"sku" : "BIS-FLF-PARTY",
		"name" : "Flying Fish Biscuits",
		"weight" : 10,
		"unit" : "g"
	},
	{
		"sku" : "PAT-HAP-PARTY",
		"name" : "Happy Pineapple Tarts",
		"weight" : 10,
		"unit" : "g"
	},
	{
		"sku" : "BIS-SEA-PARTY",
		"name" : "Nori Seaweed Biscuits",
		"weight" : 10,
		"unit" : "g"
	},
	{
		"sku" : "ICG-TRA-PARTY",
		"name" : "Nostalgic Iced Gem",
		"weight" : 10,
		"unit" : "g"
	},
	{
		"sku" : "RCRA-BBQ-PARTY",
		"name" : "Senbei Rice Crackers",
		"weight" : 10,
		"unit" : "g"
	},
	{
		"sku" : "TAP-FRI-PARTY",
		"name" : "Shredded Tapioca Fries",
		"weight" : 10,
		"unit" : "g"
	}
];

const childrenBiscuitsGiftOptions = [
	{
		"sku" : "BIS-ABC-GIFT",
		"name" : "ABC Alphabet Biscuits",
		"weight" : 30,
		"unit" : "g"
	},
	{
		"sku" : "CRA-BMU-GIFT",
		"name" : "Butter Murukku Crackers",
		"weight" : 30,
		"unit" : "g"
	},
	{
		"sku" : "BIS-EAR-GIFT",
		"name" : "Butterfly Ear Biscuits",
		"weight" : 30,
		"unit" : "g"
	},
	{
		"sku" : "POP-CAR-GIFT",
		"name" : "Caramel Poofy Popcorn",
		"weight" : 12,
		"unit" : "g"
	},
	{
		"sku" : "CRA-PWH-GIFT",
		"name" : "Couch Potato Wheel Crackers",
		"weight" : 10,
		"unit" : "g"
	},
	{
		"sku" : "MIX-FBB-GIFT",
		"name" : "Flying Burger Balls Medley",
		"weight" : 30,
		"unit" : "g"
	},
	{
		"sku" : "BIS-FLF-GIFT",
		"name" : "Flying Fish Biscuits",
		"weight" : 30,
		"unit" : "g"
	},
	{
		"sku" : "PAT-HAP-GIFT",
		"name" : "Happy Pineapple Tarts",
		"weight" : 30,
		"unit" : "g"
	},
	{
		"sku" : "BIS-SEA-GIFT",
		"name" : "Nori Seaweed Biscuits",
		"weight" : 30,
		"unit" : "g"
	},
	{
		"sku" : "ICG-TRA-GIFT",
		"name" : "Nostalgic Iced Gem",
		"weight" : 30,
		"unit" : "g"
	},
	{
		"sku" : "RCRA-BBQ-GIFT",
		"name" : "Senbei Rice Crackers",
		"weight" : 30,
		"unit" : "g"
	},
	{
		"sku" : "TAP-FRI-GIFT",
		"name" : "Shredded Tapioca Fries",
		"weight" : 30,
		"unit" : "g"
	}
];